<template>
  <div>
    <el-table :data="dataList"
              border
              style="width: 100%; max-width: 100%;"
              v-loading="dataListLoading"
              >
      <template slot="empty">
        <img src="@/assets/img/good/noGood.png">
        <div>暂无数据</div>
      </template>
      <el-table-column type="index"
                       label="序号"
                       header-align="center"
                       align="center"
                       width="50"></el-table-column>
      <el-table-column prop="name"
                       label="名称"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="mobile"
                       label="手机"
                       header-align="center"
                       align="center"></el-table-column>
      <el-table-column prop="status"
                       label="状态"
                       header-align="center"
                       align="center">
        <template slot-scope="scope">
          <el-tag type="success"
                  v-if="scope.row.status === '20'">已同意</el-tag>
          <el-tag v-if="scope.row.status === '10'">申请加入</el-tag>
          <el-tag type="danger"
                  v-if="scope.row.status === '30'">已拒绝</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status"
                       label="操作"
                       width="100"
                       header-align="center"
                       align="center">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     v-if="scope.row.status === '10'"
                     @click="ageee(scope.row.custId)">同意</el-button>
          <el-button type="text"
                     size="small"
                     v-if="scope.row.status === '10'"
                     @click="unagree(scope.row.custId)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="getDataList">
    </el-pagination>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList: [],
      dataListLoading: false,
      // 分页
      page: 1,
      limit: 10,
      total: 0
    }
  },

  methods: {
    ageee (custId) {
      this.$confirm('同意加入申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(`/front/consumer/usercenter/agree-to-join/${custId}`).then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.bus.$emit('getUserNumber')
            this.getDataList()
          }
        })
      }).catch(() => { })
    },
    unagree (custId) {
      this.$confirm('拒绝加入申请?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(`/front/consumer/usercenter/refuse-to-join/${custId}`).then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.bus.$emit('getUserNumber')
            this.getDataList()
          }
        })
      }).catch(() => { })
    },
    // getDataList () {
    //   this.$http.get(`/front/consumer/usercenter/apply-users`, {
    //     params: {
    //       companyId: this.$store.state.user.defaultCompanyId
    //     }
    //   }).then(({ data: res }) => {
    //     if (res.code === 0) {
    //       this.dataList = res.data
    //     }
    //   })
    // },
    getDataList (page = this.page) {
      this.page = page
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/usercenter/apply-users/page`, {
        page: page,
        limit: this.limit,
        companyId: this.$store.state.user.defaultCompanyId,
        // ...this.dataForm
      })
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            return false
          }
          this.dataList = res.data.data || []
          this.total = res.data.count
        }).catch(() => {
          this.dataListLoading = false
        })
    },
    pageSizeChangeHandle (val) {
      this.limit = val
      this.getDataList(1)
    },
  }
}
</script>

<style></style>
